var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card card-chat-booking float-left ml-3" }, [
    _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "mb-3" }, [
        _c("b", [_vm._v(_vm._s(_vm.message.text))]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex mt-3" }, [
          _c("div", { staticClass: "flex-fill" }, [
            _c("div", { staticClass: "exp" }, [
              _c("div", { staticClass: "checkbox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.hasIroningBoard,
                      expression: "hasIroningBoard"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    id: "hasIroningBoard",
                    name: "hasIroningBoard"
                  },
                  domProps: {
                    value: 1,
                    checked: _vm._q(_vm.hasIroningBoard, 1)
                  },
                  on: {
                    change: function($event) {
                      _vm.hasIroningBoard = 1
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "mb-0", attrs: { for: "hasIroningBoard" } },
                  [
                    _c("span"),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("message.confirm.yes")) +
                        "\n              "
                    )
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex-fill" }, [
            _c("div", { staticClass: "exp" }, [
              _c("div", { staticClass: "checkbox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.hasIroningBoard,
                      expression: "hasIroningBoard"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    id: "hasNoIroningBoard",
                    name: "hasIroningBoard"
                  },
                  domProps: {
                    value: 0,
                    checked: _vm._q(_vm.hasIroningBoard, 0)
                  },
                  on: {
                    change: function($event) {
                      _vm.hasIroningBoard = 0
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "mb-0", attrs: { for: "hasNoIroningBoard" } },
                  [
                    _c("span"),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("message.confirm.no")) +
                        "\n              "
                    )
                  ]
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.errors.has("hasIroningBoard")
          ? _c("div", { staticClass: "mt-1 text-remark -status-alert" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("message.required_selection")) +
                  "\n      "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "pt-3" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-info btn-block",
              on: {
                click: function($event) {
                  return _vm.submit()
                }
              }
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("message.button.submit")) +
                  "\n        "
              )
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e9e852c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e9e852c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chatBooking/components/HasIroningBoardMessage.vue
// module id = 2223
// module chunks = 0